import {
  ClusterWorkloads,
  NodeMigrationStatusMigrationStatusEnum,
  AutoscalerRebalancingPlan,
  RebalancingPlanOperationTypeEnum,
  RebalancingPlanStatusEnum,
  WorkloadCostImpactLevelEnum,
  WorkloadMigrationStatusMigrationStatusEnum,
  RebalancingNode,
} from '@cast/types';

// TODO (Justas): Libs splitting - move fixtures to their features
type RebalanceNodeTableEntry = {
  id?: string;
  name: string;
  instanceType: string;
  status: NodeMigrationStatusMigrationStatusEnum;
  pods: number;
  problematicPods: number;
  createdAt?: string;
  createdBy?: string;
};

type AggregatedRebalancingNode = RebalancingNode & {
  quantity: number;
  totalMemoryGib: number;
  totalCPU: number;
  priceMonthly: number;
  blendedHourlyPricePerCpu: number;
  problematic: boolean;
  affected: boolean;
  original: RebalanceNodeTableEntry[];
};

enum RebalancingCreateNodeOperationParamsCspEnum {
  aws = 'aws',
  gcp = 'gcp',
  azure = 'azure',
  do = 'do',
}

enum RebalancingNodeManagedByEnum {
  CASTAI = 'CASTAI',
  EKS = 'EKS',
  GKE = 'GKE',
  AKS = 'AKS',
  KOPS = 'KOPS',
  eks = 'eks',
  gke = 'gke',
  aks = 'aks',
  kops = 'kops',
}

const workloadsResponse: ClusterWorkloads = {
  clusterId: '45b61f97-cc37-4cc9-9939-c58579d06f3b',
  workloads: [
    {
      name: 'castai-agent-669bc765cd',
      resource: 'ReplicaSet',
      namespace: 'castai-agent',
      costImpact: { level: WorkloadCostImpactLevelEnum.low, value: 0 },
      replicas: 1,
      milliCpu: 100,
      memoryMib: 256,
      nodes: [
        {
          id: '32f272b9-a849-4d0f-a2ab-8dbe59769ff3',
          name: 'ip-192-168-62-163.eu-central-1.compute.internal',
          specs: { milliCpu: 2000, memoryMib: 8192, instanceType: 'm5.large' },
          status: {
            migrationStatus: NodeMigrationStatusMigrationStatusEnum.ready,
          },
          totalPods: 3,
          totalProblematicPods: 0,
          workloadReplicas: 0,
        },
      ],
      status: {
        migrationStatus: WorkloadMigrationStatusMigrationStatusEnum.ready,
      },
      issues: [],
    },
    {
      name: 'aws-node',
      resource: 'DaemonSet',
      namespace: 'kube-system',
      costImpact: { level: WorkloadCostImpactLevelEnum.low, value: 0 },
      replicas: 2,
      milliCpu: 20,
      memoryMib: 0,
      nodes: [
        {
          id: '32f272b9-a849-4d0f-a2ab-8dbe59769ff3',
          name: 'ip-192-168-62-163.eu-central-1.compute.internal',
          specs: { milliCpu: 2000, memoryMib: 8192, instanceType: 'm5.large' },
          status: {
            migrationStatus: NodeMigrationStatusMigrationStatusEnum.ready,
          },
          totalPods: 3,
          totalProblematicPods: 0,
          workloadReplicas: 0,
        },
        {
          id: 'f6ce156f-a83f-46b1-8eb9-f059d118b1b0',
          name: 'ip-192-168-16-199.eu-central-1.compute.internal',
          specs: { milliCpu: 2000, memoryMib: 8192, instanceType: 'm5.large' },
          status: {
            migrationStatus: NodeMigrationStatusMigrationStatusEnum.ready,
          },
          totalPods: 4,
          totalProblematicPods: 0,
          workloadReplicas: 0,
        },
      ],
      status: {
        migrationStatus: WorkloadMigrationStatusMigrationStatusEnum.ready,
      },
      issues: [],
    },
    {
      name: 'coredns-7cfc675d7d',
      resource: 'ReplicaSet',
      namespace: 'kube-system',
      costImpact: { level: WorkloadCostImpactLevelEnum.low, value: 0 },
      replicas: 2,
      milliCpu: 200,
      memoryMib: 140,
      nodes: [
        {
          id: 'f6ce156f-a83f-46b1-8eb9-f059d118b1b0',
          name: 'ip-192-168-16-199.eu-central-1.compute.internal',
          specs: { milliCpu: 2000, memoryMib: 8192, instanceType: 'm5.large' },
          status: {
            migrationStatus: NodeMigrationStatusMigrationStatusEnum.ready,
          },
          totalPods: 4,
          totalProblematicPods: 0,
          workloadReplicas: 0,
        },
      ],
      status: {
        migrationStatus: WorkloadMigrationStatusMigrationStatusEnum.ready,
      },
      issues: [],
    },
    {
      name: 'kube-proxy',
      resource: 'DaemonSet',
      namespace: 'kube-system',
      costImpact: { level: WorkloadCostImpactLevelEnum.low, value: 0 },
      replicas: 2,
      milliCpu: 200,
      memoryMib: 0,
      nodes: [
        {
          id: '32f272b9-a849-4d0f-a2ab-8dbe59769ff3',
          name: 'ip-192-168-62-163.eu-central-1.compute.internal',
          specs: { milliCpu: 2000, memoryMib: 8192, instanceType: 'm5.large' },
          status: {
            migrationStatus: NodeMigrationStatusMigrationStatusEnum.ready,
          },
          totalPods: 3,
          totalProblematicPods: 0,
          workloadReplicas: 0,
        },
        {
          id: 'f6ce156f-a83f-46b1-8eb9-f059d118b1b0',
          name: 'ip-192-168-16-199.eu-central-1.compute.internal',
          specs: { milliCpu: 2000, memoryMib: 8192, instanceType: 'm5.large' },
          status: {
            migrationStatus: NodeMigrationStatusMigrationStatusEnum.ready,
          },
          totalPods: 4,
          totalProblematicPods: 0,
          workloadReplicas: 0,
        },
      ],
      status: {
        migrationStatus: WorkloadMigrationStatusMigrationStatusEnum.ready,
      },
      issues: [],
    },
  ],
};

const rebalancePlanResponse: AutoscalerRebalancingPlan = {
  clusterId: '45b61f97-cc37-4cc9-9939-c58579d06f3b',
  rebalancingPlanId: 'a476155c-f34a-47ba-8b66-e321ea96d7e0',
  createdAt: '2021-10-25T10:12:37.616539Z',
  updatedAt: '2021-10-25T10:14:59.434956Z',
  minNodes: 3,
  status: RebalancingPlanStatusEnum.generated,
  rebalancingNodeIds: [],
  executionConditions: {},
  evictGracefully: false,
  configurations: {
    blue: {
      nodes: [
        {
          isControlPlane: false,
          isSpotFallback: false,
          instanceType: 't3.large',
          milliCpu: 2000,
          memoryMib: 8192,
          isSpot: false,
          priceHourly: '0.0960000000',
          isLegacy: true,
          totalPods: 4,
          name: 'ip-192-168-79-0.eu-central-1.compute.internal',
          managedBy: RebalancingNodeManagedByEnum.EKS,
          totalProblematicPods: 0,
          createdAt: '2021-10-25T08:56:14Z',
        },
        {
          isControlPlane: false,
          isSpotFallback: false,
          instanceType: 't3.large',
          milliCpu: 2000,
          memoryMib: 8192,
          isSpot: false,
          priceHourly: '0.0960000000',
          isLegacy: true,
          totalPods: 5,
          name: 'ip-192-168-30-192.eu-central-1.compute.internal',
          managedBy: RebalancingNodeManagedByEnum.EKS,
          totalProblematicPods: 0,
          createdAt: '2021-10-25T08:56:11Z',
        },
        {
          isControlPlane: false,
          isSpotFallback: false,
          instanceType: 't3.large',
          milliCpu: 2000,
          memoryMib: 8192,
          isSpot: false,
          priceHourly: '0.0960000000',
          isLegacy: true,
          totalPods: 3,
          name: 'ip-192-168-36-196.eu-central-1.compute.internal',
          managedBy: RebalancingNodeManagedByEnum.EKS,
          totalProblematicPods: 0,
          createdAt: '2021-10-25T08:56:17Z',
        },
      ],
      totals: {
        nodes: 3,
        replaceableNodes: 3,
        migratablePods: 12,
        milliCpu: 6000,
        memoryMib: 24576,
        priceHourly: '0.2880000000',
        priceMonthly: '210.2400000000',
        pods: 12,
        problematicPods: 0,
      },
    },
    green: {
      nodes: [
        {
          isControlPlane: false,
          isSpotFallback: false,
          instanceType: 'c5a.large',
          milliCpu: 2000,
          memoryMib: 4096,
          isSpot: false,
          priceHourly: '0.0870000000',
          isLegacy: false,
          totalPods: 3,
          name: 'rebalanced-node-c5a-large-1',
          managedBy: RebalancingNodeManagedByEnum.CASTAI,
          totalProblematicPods: 0,
          createdAt: '2021-10-25T10:13:49.315682875Z',
        },
        {
          isControlPlane: false,
          isSpotFallback: false,
          instanceType: 'c5a.large',
          milliCpu: 2000,
          memoryMib: 4096,
          isSpot: false,
          priceHourly: '0.0870000000',
          isLegacy: false,
          totalPods: 2,
          name: 'rebalanced-node-c5a-large-2',
          managedBy: RebalancingNodeManagedByEnum.CASTAI,
          totalProblematicPods: 0,
          createdAt: '2021-10-25T10:13:49.315894504Z',
        },
        {
          isControlPlane: false,
          isSpotFallback: false,
          instanceType: 'c5a.large',
          milliCpu: 2000,
          memoryMib: 4096,
          isSpot: false,
          priceHourly: '0.0870000000',
          isLegacy: false,
          totalPods: 1,
          name: 'rebalanced-node-c5a-large-3',
          managedBy: RebalancingNodeManagedByEnum.CASTAI,
          totalProblematicPods: 0,
          createdAt: '2021-10-25T10:13:49.316101603Z',
        },
      ],
      totals: {
        nodes: 3,
        replaceableNodes: 3,
        migratablePods: 6,
        milliCpu: 6000,
        memoryMib: 12288,
        priceHourly: '0.2610000000',
        priceMonthly: '190.5300000000',
        pods: 6,
        problematicPods: 0,
      },
    },
    diff: {
      priceHourly: '0.0270000000',
      priceMonthly: '19.7100000000',
      savingsPercentage: '9.3750000000',
    },
  },
  operations: [
    {
      id: '55db786c-e6df-4088-9db2-c1880118244e',
      nodeId: '7fbf20dd-1afa-4e55-92d6-046439c6d937',
      type: RebalancingPlanOperationTypeEnum.create_node,
      createdAt: '2021-10-25T10:13:25.915770Z',
      finishedAt: '2021-10-25T10:13:35.915770Z',
      createParams: {
        csp: RebalancingCreateNodeOperationParamsCspEnum.aws,
        instanceType: 'c5a.large',
        volumeSizeGib: 100,
        isSpot: false,
        isSpotFallback: false,
        nodeConfigurationId: '1',
        azName: 'eu-central-1b',
        subnetId: 'subnet-0b6f96e4bcccb6ec5',
      },
    },
    {
      id: '26810451-7d38-46ba-9bd1-cbf874eb4170',
      nodeId: '556ade54-427f-40ba-88f6-26d00d300549',
      type: RebalancingPlanOperationTypeEnum.create_node,
      createdAt: '2021-10-25T10:13:25.915774Z',
      createParams: {
        csp: RebalancingCreateNodeOperationParamsCspEnum.aws,
        instanceType: 'c5a.large',
        volumeSizeGib: 100,
        isSpot: false,
        isSpotFallback: false,
        azName: 'eu-central-1b',
        nodeConfigurationId: '1',
        subnetId: 'subnet-0b6f96e4bcccb6ec5',
      },
    },
    {
      id: '0aa41c9b-c924-4a4f-8333-b57eff1fb63f',
      nodeId: '6cc95a97-a4fa-4ce6-871b-4167d5ae1167',
      type: RebalancingPlanOperationTypeEnum.create_node,
      createdAt: '2021-10-25T10:13:25.915776Z',
      createParams: {
        csp: RebalancingCreateNodeOperationParamsCspEnum.aws,
        instanceType: 'c5a.large',
        volumeSizeGib: 100,
        isSpot: false,
        nodeConfigurationId: '1',
        isSpotFallback: false,
        azName: 'eu-central-1b',
        subnetId: 'subnet-0b6f96e4bcccb6ec5',
      },
    },
    {
      id: '4182f780-c902-4df1-a167-24224d8fedc6',
      nodeId: '6fa76504-5c06-47b9-a440-ad30f7af2c4a',
      type: RebalancingPlanOperationTypeEnum.drain_node,
      createdAt: '2021-10-25T10:13:25.915778Z',
      drainParams: {},
    },
    {
      id: 'df649ef3-eb29-44e1-8734-f59cf4237f8d',
      nodeId: 'ec8a1bd6-821e-4d8b-b284-a160d68d072b',
      type: RebalancingPlanOperationTypeEnum.drain_node,
      createdAt: '2021-10-25T10:13:25.915780Z',
      drainParams: {},
    },
    {
      id: '75a29765-a216-476e-ae02-56c76fe58ae8',
      nodeId: '8d17b0d6-c44a-42db-b0fd-4e4e226274f8',
      type: RebalancingPlanOperationTypeEnum.drain_node,
      createdAt: '2021-10-25T10:13:25.915782Z',
      drainParams: {},
    },
    {
      id: '4e9fe581-f880-41bf-b5ad-c905878c4551',
      nodeId: '6fa76504-5c06-47b9-a440-ad30f7af2c4a',
      type: RebalancingPlanOperationTypeEnum.delete_node,
      createdAt: '2021-10-25T10:13:25.915784Z',
      deleteParams: {},
    },
    {
      id: 'b8edcb7f-13ca-49bd-b44f-3ba98dc7c45d',
      nodeId: 'ec8a1bd6-821e-4d8b-b284-a160d68d072b',
      type: RebalancingPlanOperationTypeEnum.delete_node,
      createdAt: '2021-10-25T10:13:25.915786Z',
      deleteParams: {},
    },
    {
      id: 'a398b3e7-c422-4e33-84f2-6f0df19abc0b',
      nodeId: '8d17b0d6-c44a-42db-b0fd-4e4e226274f8',
      type: RebalancingPlanOperationTypeEnum.delete_node,
      createdAt: '2021-10-25T10:13:25.915788Z',
      deleteParams: {},
    },
  ],
  generatedAt: '2021-10-25T10:13:49.316135Z',
};

const aggregatedBlueNodesByInstance: AggregatedRebalancingNode[] = [
  {
    isControlPlane: false,
    isSpotFallback: false,
    instanceType: 't3.large',
    milliCpu: 2000,
    memoryMib: 8192,
    isSpot: false,
    priceHourly: '0.0960000000',
    isLegacy: true,
    totalPods: 12,
    name: 'ip-192-168-79-0.eu-central-1.compute.internal',
    managedBy: RebalancingNodeManagedByEnum.EKS,
    totalProblematicPods: 0,
    createdAt: '2021-10-25T08:56:14Z',
    quantity: 3,
    totalMemoryGib: 24,
    totalCPU: 6,
    priceMonthly: 210.24000000000004,
    blendedHourlyPricePerCpu: 0.04800000000000001,
    problematic: false,
    affected: true,
    original: [
      {
        name: 'ip-192-168-79-0.eu-central-1.compute.internal',
        instanceType: 't3.large',
        createdAt: '2021-10-25T08:56:14Z',
        createdBy: 'EKS',
        status: NodeMigrationStatusMigrationStatusEnum.ready,
        pods: 4,
        problematicPods: 0,
      },
      {
        name: 'ip-192-168-30-192.eu-central-1.compute.internal',
        instanceType: 't3.large',
        createdAt: '2021-10-25T08:56:11Z',
        createdBy: 'EKS',
        status: NodeMigrationStatusMigrationStatusEnum.ready,
        pods: 5,
        problematicPods: 0,
      },
      {
        name: 'ip-192-168-36-196.eu-central-1.compute.internal',
        instanceType: 't3.large',
        createdAt: '2021-10-25T08:56:17Z',
        createdBy: 'EKS',
        status: NodeMigrationStatusMigrationStatusEnum.ready,
        pods: 3,
        problematicPods: 0,
      },
    ],
  },
];

const aggregatedGreenNodesByInstance: AggregatedRebalancingNode[] = [
  {
    isControlPlane: false,
    isSpotFallback: false,
    instanceType: 'c5a.large',
    milliCpu: 2000,
    memoryMib: 4096,
    isSpot: false,
    priceHourly: '0.0870000000',
    isLegacy: false,
    totalPods: 6,
    name: 'rebalanced-node-c5a-large-1',
    managedBy: RebalancingNodeManagedByEnum.CASTAI,
    totalProblematicPods: 0,
    createdAt: '2021-10-25T10:13:49.315682875Z',
    quantity: 3,
    totalMemoryGib: 12,
    totalCPU: 6,
    priceMonthly: 190.53,
    blendedHourlyPricePerCpu: 0.043500000000000004,
    problematic: false,
    affected: true,
    original: [
      {
        name: 'rebalanced-node-c5a-large-1',
        instanceType: 'c5a.large',
        createdAt: '2021-10-25T10:13:49.315682875Z',
        createdBy: 'CASTAI',
        status: NodeMigrationStatusMigrationStatusEnum.ready,
        pods: 3,
        problematicPods: 0,
      },
      {
        name: 'rebalanced-node-c5a-large-2',
        instanceType: 'c5a.large',
        createdAt: '2021-10-25T10:13:49.315894504Z',
        createdBy: 'CASTAI',
        status: NodeMigrationStatusMigrationStatusEnum.ready,
        pods: 2,
        problematicPods: 0,
      },
      {
        name: 'rebalanced-node-c5a-large-3',
        instanceType: 'c5a.large',
        createdAt: '2021-10-25T10:13:49.316101603Z',
        createdBy: 'CASTAI',
        status: NodeMigrationStatusMigrationStatusEnum.ready,
        pods: 1,
        problematicPods: 0,
      },
    ],
  },
];

const problematicNodes: AggregatedRebalancingNode[] = [
  {
    isControlPlane: false,
    isSpotFallback: false,
    instanceType: 't3.large',
    milliCpu: 2000,
    memoryMib: 8192,
    isSpot: false,
    priceHourly: '0.0960000000',
    isLegacy: true,
    totalPods: 12,
    name: 'ip-192-168-79-0.eu-central-1.compute.internal',
    managedBy: RebalancingNodeManagedByEnum.EKS,
    totalProblematicPods: 0,
    createdAt: '2021-10-25T08:56:14Z',
    quantity: 3,
    totalMemoryGib: 24,
    totalCPU: 6,
    priceMonthly: 210.24000000000004,
    blendedHourlyPricePerCpu: 0.04800000000000001,
    problematic: false,
    affected: true,
    original: [
      {
        name: 'ip-192-168-79-0.eu-central-1.compute.internal',
        instanceType: 't3.large',
        createdAt: '2021-10-25T08:56:14Z',
        createdBy: 'EKS',
        status: NodeMigrationStatusMigrationStatusEnum.ready,
        pods: 4,
        problematicPods: 0,
      },
      {
        name: 'ip-192-168-30-192.eu-central-1.compute.internal',
        instanceType: 't3.large',
        createdAt: '2021-10-25T08:56:11Z',
        createdBy: 'EKS',
        status: NodeMigrationStatusMigrationStatusEnum.ready,
        pods: 5,
        problematicPods: 0,
      },
      {
        name: 'ip-192-168-36-196.eu-central-1.compute.internal',
        instanceType: 't3.large',
        createdAt: '2021-10-25T08:56:17Z',
        createdBy: 'EKS',
        status: NodeMigrationStatusMigrationStatusEnum.ready,
        pods: 3,
        problematicPods: 0,
      },
    ],
  },
];

export const rebalanceFixtures = {
  workloadsResponse,
  rebalancePlanResponse,
  aggregatedBlueNodesByInstance,
  aggregatedGreenNodesByInstance,
  problematicNodes,
};
